<app-nav></app-nav>

<div *ngIf="isLoading" class="outer-spinner">
  <div class="loading-spinner"></div>
</div>

<main class="page" *ngIf="!isLoading">

  <section class="head">
    <div class="head-bg" style="background-image: url('assets/requests/hero-bg.jpg')"></div>
    <div class="head-text">
      <h1>Requests</h1>
      <p>Manage incoming requests, collaboration opportunities,<br />partnerships and more.</p>
    </div>
    <div class="head-quote">Connect<br />Collaborate<br /><span>Create<br />Grow Together</span></div>
  </section>

  <section class="stats">
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-envelope"></i></div>
      <div><span>Total Requests</span><b>{{ all.length }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-inbox"></i></div>
      <div><span>Received</span><b>{{ count('received') }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-paper-plane"></i></div>
      <div><span>Sent</span><b>{{ count('sent') }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-hourglass-half"></i></div>
      <div><span>Pending</span><b>{{ pending() }}</b></div>
    </div>
    <div class="stat">
      <div class="stat-ico"><i class="fa-solid fa-handshake"></i></div>
      <div><span>Accepted</span><b>{{ count('accepted') }}</b></div>
    </div>
  </section>

  <section class="toolbar">
    <div class="tabs">
      <button type="button" *ngFor="let t of tabs" [class.active]="tab === t.key" (click)="tab = t.key">
        {{ t.label }} ({{ count(t.key) }})
      </button>
    </div>
    <div class="tools">
      <div class="t-search">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="search" placeholder="Search requests..." [(ngModel)]="searchText" autocomplete="off" />
      </div>
      <div class="t-sort">
        <i class="fa-solid fa-arrow-down-wide-short"></i>
        <select [(ngModel)]="sortBy">
          <option value="newest">Newest First</option>
          <option value="name">Name A-Z</option>
        </select>
      </div>
    </div>
  </section>

  <section class="layout">

    <div class="list-card">
      <ul class="rows" *ngIf="filtered.length > 0">
        <li *ngFor="let r of filtered">
          <img [src]="r.photo || 'assets/images/avatar.png'"
               (error)="$any($event.target).src='assets/images/avatar.png'" class="av" alt="" />

          <div class="who">
            <b>{{ r.name }}</b>
            <small>{{ r.sub }}</small>
          </div>

          <span class="type" [ngClass]="r.dir === 'received' ? 't-recv' : (r.dir === 'sent' ? 't-sent' : 't-conn')">
            {{ r.dir === 'received' ? 'Received' : (r.dir === 'sent' ? 'Sent' : 'Friend') }}
          </span>

          <p class="msg">
            <ng-container *ngIf="r.status === 'Accepted'">You are connected.</ng-container>
            <ng-container *ngIf="r.status !== 'Accepted' && r.dir === 'received'">Wants to connect with you.</ng-container>
            <ng-container *ngIf="r.status !== 'Accepted' && r.dir !== 'received'">You sent a connection request.</ng-container>
          </p>

          <span class="time">{{ ago(r.created) }}</span>

          <div class="acts">
            <button type="button" class="b-pink" *ngIf="r.dir === 'received' && r.status === 'Pending'"
                    [disabled]="acceptingId === r.id" (click)="accept(r)">
              {{ acceptingId === r.id ? '...' : 'Accept' }}
            </button>
            <span class="st st-pending" *ngIf="r.dir === 'sent' && r.status === 'Pending'">Pending</span>
            <span class="st st-ok" *ngIf="r.status === 'Accepted'"><i class="fa-solid fa-circle-check"></i> Accepted</span>
            <button type="button" class="b-out" *ngIf="r.status === 'Accepted'" (click)="message()">Message</button>
          </div>
        </li>
      </ul>

      <div class="empty" *ngIf="filtered.length === 0">
        <div class="empty-ico"><i class="fa-solid fa-handshake"></i></div>
        <h3>{{ all.length === 0 ? 'No requests yet' : 'No requests match this filter' }}</h3>
        <p>Search for people and connect, or check your contacts.</p>
        <a routerLink="/contact" class="b-pink link">View Contacts</a>
      </div>
    </div>

    <aside class="side">
      <div class="side-card">
        <h4><i class="fa-solid fa-chart-pie"></i> Request Status</h4>
        <div class="srow"><span><i class="dot ok"></i> Accepted</span><b>{{ count('accepted') }}</b></div>
        <div class="srow"><span><i class="dot pend"></i> Pending</span><b>{{ pending() }}</b></div>
      </div>
      <div class="side-card quote">“Together<br />We Create<br /><span>Real Impact.</span>”</div>
    </aside>
  </section>
</main>